import { Alert, AlertProps } from '@mui/material'

type UnsetAlertProps = {
  icon?: React.ReactNode
  children: React.ReactNode
  sx?: AlertProps['sx']
}

export const UnsetAlert: React.FC<UnsetAlertProps> = ({ icon, children, sx }) => {
  return (
    <Alert
      icon={icon ? icon : false}
      sx={{
        border: '1px dashed grey',
        color: 'grey',
        backgroundColor: 'transparent',
        ...sx,
      }}
    >
      {children}
    </Alert>
  )
}
